<script setup lang="ts">
import bg1 from "@/assets/images/backgroundServices/carousel/img1TMS.png";
import bg2 from "@/assets/images/backgroundServices/carousel/img2.png";
import bg3 from "@/assets/images/backgroundServices/carousel/img3.png";
// step-icons
import icon1 from "@/assets/images/backgroundServices/detailsIcon/step-icons.svg";
import icon2 from "@/assets/images/backgroundServices/detailsIcon/step-icons1.svg";
import icon3 from "@/assets/images/backgroundServices/detailsIcon/step-icons2.svg";
// details
import developer_mode_tv from "@/assets/images/backgroundServices/detailsIcon/developer_mode_tv.svg";
import data_obj from "@/assets/images/backgroundServices/detailsIcon/data_object.svg";
import forum from "@/assets/images/backgroundServices/detailsIcon/forum.svg";
import percent_discount from "@/assets/images/backgroundServices/detailsIcon/percent_discount.svg";

const images = [bg1, bg2, bg3];

// wrapp-steps data
const steps = [
	{
		icon: icon1,
		title: "Step 1",
		subTitle: "First week",
		text: "Team introductions, strategic and operational meetings. Tech talk and task breakdown. Timelines and milestones.",
	},
	{
		icon: icon2,
		title: "Step 2",
		subTitle: "3 months",
		text: "Tech and feature demos based on agreed timeline and milestones. Regular update & alignment calls. Closed beta testing.",
	},
	{
		icon: icon3,
		title: "Step 3",
		subTitle: "12 months",
		text: "Product launch after completing all milestones and quality checks. Product becomes available to end users. Setup of maintenance and update procedures.",
	},
];
// details data

// detailsBottom data
const title = ref("What does Tailor made software entail?");
const items = ref([
	{
		icon: data_obj,
		txt: "TMS includes the entire development process (excluding design).",
	},
	{
		icon: developer_mode_tv,
		txt: "Final delivery can Include backend/server setup, UI/UX, API, system integration and more. From initial concept to final delivery, employee training and maintenance.",
	},
	{
		icon: forum,
		txt: "As well as dev support, Monday to Friday with options for expanding support to Saturday and Sunday.",
	},
	{
		icon: percent_discount,
		txt: "Possible long term deployment discounts and special services.",
	},
]);
const price = ref("3000€+");
const price_txt = ref([
	"Price example for creating a website, in the case that the product and design work is done in coordination with our team a discount is applied",
	"Final price estimation is based of design document breakdown and man hours estimate.",
	"Timeframe for specific steps is given as an example and depends mostly on client communication and availability. Given timeframes are based on creating a complex custom web product.",
]);

// end details data

onMounted(() => {
	setTimeout(() => {}, 100);
});
onUnmounted(() => {});
</script>
<template>
	<div class="service-details-page">
		<Carousel :images="images" />
		<wrapp-steps :steps="steps" />
		<detailsBottom
			:title="title"
			:items="items"
			:price="price"
			:price_txt="price_txt"
		/>
	</div>
</template>
<style lang="scss">
.service-details-page {
	background-image: url("@/assets/images/backgroundServices/whiteback.png");
	background-position: center top;
	background-repeat: no-repeat;
	// background-size: 100% auto; // cover
	background-size: cover;
	margin-top: 100px;
	min-height: calc(100vh - 100px);
}

@media screen and (width <= 768px) {
	.service-details-page {
		// set style
	}
}
</style>
